import * as yup from "yup";

export const ManageCertificateSchema = yup.object().shape({
  CertificateName: yup.string().trim().required("Please enter certificate name!").matches(
    /^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/,
    "Only alphanumeric and special characters like ':#@?[]_`| are allowed"
  ),
  CertificateFile: yup
    .mixed()
    .transform((v) => (!v ? undefined : v))
    .required("Please select certificate!"),
});
